<template>
  <div>
    <el-dialog
      ref="editDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h550_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('editDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogEditForm"
          :model="dialogEditForm"
          :rules="dialogEditFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="18">
                  <el-form-item
                    label="资产名称"
                    prop="name"
                  >
                    <el-input
                      v-model="dialogEditForm.name"
                      maxlength="128"
                      :disabled="dialogEditForm.materialsId > 0"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="计量单位"
                    prop="unit"
                  >
                    <el-input
                      v-model="dialogEditForm.unit"
                      maxlength="32"
                      :disabled="dialogEditForm.materialsId > 0"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item
                    label="规格配置"
                    prop="configSpec"
                  >
                    <el-input
                      v-model="dialogEditForm.configSpec"
                      type="textarea"
                      :disabled="dialogEditForm.materialsId > 0"
                      show-word-limit
                      maxlength="256"
                      rows="3"
                      style="margin-top: -8px;"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="管理人员">
                    <el-input
                      v-model="dialogEditForm.managerName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="管理数量">
                    <el-input
                      v-model="dialogEditForm.manageNumber"
                      @input="(val) => {limitPositiveNumber(val, dialogEditForm, 'manageNumber')}"
                      @blur="setNumberValueDefaultZero($event, dialogEditForm, 'manageNumber', 2);"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="借出数量">
                    <el-input
                      v-model="dialogEditForm.lentNumber"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="损坏遗失数量">
                    <el-input
                      v-model="dialogEditForm.damageNumber"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogEditForm.remark"
                      type="textarea"
                      placeholder="备注"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          :disabled="operateButtonDisable"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 数据请求
import { updateFixedAssetApi, initFixedAssetApi } from '@/api/fixedAsset'

export default {
  components: {},
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      operateButtonDisable: false,
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',

      dialogEditForm: {},
      dialogEditFormRules: {
        name: [{ required: false, message: '请输入固定资产名称', trigger: 'blur' }, { max: 128, message: '固定资产名称最多允许输入 128 个字符', trigger: 'blur' }],
        unit: [{ required: false, message: '请输入固定资产计量单位', trigger: 'blur' }, { max: 32, message: '固定资产计量单位最多允许输入 32 个字符', trigger: 'blur' }],
        configSpec: [{ max: 256, message: '规格配置最多允许输入 256 个字符', trigger: 'blur' }],
        remark: [{ max: 255, message: '备注最多输入255个字符', trigger: 'blur' }]
      },
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        let _this = this
        _this.loading = true
        _this.loadingText = '努力加载数据中，请耐心等待'
        _this.operateButtonDisable = false

        _this.dialogEditForm = {}
        _this.initFixedAssetData()

        _this.$nextTick(() => {
          _this.$refs.dialogEditForm.clearValidate()
          _this.loading = false
        })
      }
    }
  },
  methods: {
    // 初始化固定资产数据
    initFixedAssetData() {
      let _this = this
      initFixedAssetApi({ id: _this.dataId }).then(response => {
        const { data } = response
        _this.dialogEditForm = data || {}
        if (_this.dialogEditForm.materialsId === 0) {
          _this.dialogEditFormRules.name[0].required = true;
          _this.dialogEditFormRules.unit[0].required = true;
        }
      })
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogEditForm.clearValidate()
    },
    // 新增|修改保存
    handleSave() {
      let _this = this
      _this.$refs.dialogEditForm.validate(valid => {
        if (valid) {
          this.$confirm('是否确定保存固定资产', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
            _this.operateButtonDisable = true
            _this.loading = true
            _this.loadingText = '正在处理数据中，请耐心等待'

            updateFixedAssetApi(_this.dialogEditForm).then(res => {
              _this.$message({ message: res.message, type: 'success' })
              _this.reloadData()
              _this.modalClose()
            }).catch(() => {
              _this.loading = false
              _this.operateButtonDisable = false
            })
          }).catch(() => { })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
  .cell {
    line-height: 16px;
  }
}

::v-deep .el-table__row {
  .el-form-item__error {
    display: none;
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 0px;
  }
}

.source-textarea {
  ::v-deep .el-textarea__inner {
    margin-top: 0px;
    font-size: 12px;
  }
}
</style>
